import NewScriptsPage from './NewScriptsPage';

export default NewScriptsPage;